import { Link } from "react-router-dom";
import SVG from "../../SVG";
import { Tooltip } from "react-tooltip";
export default function Quit() {
  return (
    <>
      <Link
        className="outline-none"
        to={"/SignIn"}
        data-tooltip-id="quitTooltip"
        data-tooltip-content="خروج"
        onClick={() => {
          localStorage.removeItem("email");
          localStorage.removeItem("refresh");
          localStorage.removeItem("access");
          localStorage.removeItem("role");
        }}
      >
        <SVG name="quit" classname="size-5 drop-shadow-md cursor-pointer" />
      </Link>

      <Tooltip
        id="quitTooltip"
        place="bottom"
        className="z-50 !py-1 !px-2 !text-xs !font-thin !backdrop-blur !bg-zi-blue-dark !rounded-lg"
      />
    </>
  );
}
